export const SET_ERROR = 'SET_ERROR'

export const SET_IMAGE = 'IMAGE_SET_IMAGE';
export const SET_NAME = 'IMAGE_SET_NAME';
export const SET_FORMAT = 'IMAGE_SET_FORMAT';
export const SET_DIMENSION = 'IMAGE_SET_DIMENSION';

export const CANVAS_SET_IMAGE = "CANVAS_SET_IMAGE";
export const CANVAS_SET_DIMENSION = 'CANVAS_SET_DIMENSION';

export const SHOW_POPUP = "SHOW_POPUP";

export const CANVAS_SET_FLIP_VERTICAL = "CANVAS_SET_FLIP_VERTICAL";

export const CANVAS_SET_FLIP_HORIZONTAL = "CANVAS_SET_FLIP_HORIZONTAL";
export const CANVAS_SET_IS_CHANGED = 'CANVAS_SET_IS_CHANGED';
export const CANVAS_SET_SAVE_PROPORTIONS = 'CANVAS_SET_SAVE_PROPORTIONS'

export const CANVAS_SET_CROP_DIMENSIONS = 'CANVAS_SET_CROP_DIMENSIONS';
export const CANVAS_SET_VALIDATION = 'CANVAS_SET_VALIDATION';

export const SERVICE_SET_CROP_DIMENSIONS = 'SERVICE_SET_CROP_DIMENSIONS';

export const SERVICE_SET_CROP_POSITION = 'SERVICE_SET_CROP_POSITION';
export const SET_ROTATED = "CANVAS_SET_ROTATED"

export const SET_PREVIEW_POSITION = "PREVIEW_SET_POSITION"; 
export const SET_PRESERVATION_PROPORTIONS = "SET_PRESERVATION_PROPORTIONS";
export const CANVAS_SET_FORMAT = "CANVAS_SET_FORMAT"; 
